export default {
  POSITIVE: 4,
  NEGATIVE: 3,
};
